export default __webpack_public_path__ + "static/media/slider-cregar-1.2ce0cf4e.jpg";